module.exports = __webpack_public_path__ + "img/cover.77859494.jpg";